<template>
  <div class="realize_wrap">
    <div
        class="realize_img"
        v-if="hiddenFiveNavOne1"
        :style="{ background: `url(${prodFive1.image}) 0 0 no-repeat`, backgroundSize: 'cover' }"
    >
      <div class="img_tit">{{ prodFive1.title }}</div>
    </div>

    <!-- 公司介绍模块 -->
    <div class="com-intro-wrap" v-if="comIntroHidden && comIntroList.length">
      <div class="container">
        <div class="intro-title">Company Profile</div>
        <div class="intro-item" v-for="(item, index) in comIntroList" :key="index">
          <div class="item-box" :class="{ reverse: index % 2 === 1 }">
            <div class="item-img">
              <img :src="item.imgUrl" alt="" />
            </div>
            <div class="item-text">
              <p style="white-space:pre-line" v-html="item.content"></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CallMe />
  </div>
</template>

<script>
import { leftLikeDict } from '../../api/system'
import Constant from '../../utils/Constant'
import { findDictHidden, findMainProp } from '../../utils'
import CallMe from '@/components/callme/index'

export default {
  data() {
    return {
      hiddenFiveNavOne1: true,
      prodFive1: {},
      comIntroHidden: true,
      comIntroList: []
    }
  },
  methods: {
    async leftLikeDictFunc() {
      const res = await leftLikeDict(Constant.FIVENAV_ONE1);
      if (res.data) {
        this.hiddenFiveNavOne1 = findDictHidden(Constant.FIVENAV_ONE1, res.data.data)
        this.prodFive1 = findMainProp(res.data.data, Constant.FIVENAV_ONE1)
      }
    },

    async getComIntroData() {
      const res = await leftLikeDict("com_introduct");
      const dictObj = res.data;
      const dictArr = dictObj.data;

      this.comIntroHidden = findDictHidden("com_introduct", dictArr);

      const parentItem = dictArr.find(item => item.dictKey === 'com_introductTitle')
      if (!parentItem || !parentItem.children) return;
      const childList = parentItem.children;

      const map = {};
      childList.forEach(item => {
        const numReg = /com_introductContent(\d+)/;
        const result = item.dictKey.match(numReg);
        if (!result) return;
        const num = result[1];
        if (!map[num]) {
          map[num] = { num: Number(num), content: '', imgUrl: '' }
        }
        if (item.dictKey.includes('SubTitle')) {
          map[num].content = item.dictValue
        }
        if (item.dictKey.includes('Img')) {
          map[num].imgUrl = item.dictValue
        }
      })
      this.comIntroList = Object.values(map).sort((a, b) => a.num - b.num)
    }
  },
  components: {
    CallMe,
  },
  mounted() {
    this.leftLikeDictFunc();
    this.getComIntroData();
  }
}
</script>

<style lang="scss" scoped>
.realize_wrap {
  .realize_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      font-family: 'Roboto', sans-serif;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }
    }
  }

  .com-intro-wrap {
    padding:80px 0 0 0;
    font-family: 'Roboto', sans-serif;
    font-weight: 470;
    color: #0c0c0c;
    .container {
      width:93%;
      //max-width:1440px;
      margin:0 auto;
    }
    .intro-title {
      font-family: 'Roboto_Bold', sans-serif;
      font-size: 40px;
      font-weight: bold;
      margin-bottom: 25px;
      color: #000;
    }
    .intro-item {
      margin-bottom:80px;
      .item-box {
        display:flex;
        align-items:center;
        gap:50px;
        &.reverse {
          flex-direction:row-reverse;
        }
        .item-img {
          flex:0.85;
          img {
            width:100%;
            display:block;
            border-radius:4px;
          }
        }
        .item-text {
          flex:1.15;
          font-size:27px;
          line-height:1.60;
          color:#222;
          p {
            margin:0;
          }
        }
      }
    }
  }

  @media(max-width:768px){
    .com-intro-wrap {
      padding:20px 0 0 0;
      .intro-title {
        font-family: 'Roboto_Bold', sans-serif;
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 25px;
        color: #000;
      }
      .intro-item {
        margin-bottom:45px;
      }
      .intro-item .item-box {
        flex-direction:column !important;
        gap:26px;
        &.reverse {
          flex-direction:column !important;
        }
        .item-text {
          font-size:20px;
          line-height:1.70;
        }
      }
    }
  }
}
</style>